import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import StyledPlatformForExportImage from './StyledPlatformForExportImage.styles';

function PlatformForExportImage({ platform }) {
  const { t } = useTranslation();

  if (!platform) return null;

  return (
    <StyledPlatformForExportImage className='export-image-platform'>
      {platform === 'nativePlatforms'
        ? ` - ${t(`common:${platform}`)}`
        : ` - ${t('common:platform')} ${t(`common:${platform}`)}`}
    </StyledPlatformForExportImage>
  );
}

export default PlatformForExportImage;

PlatformForExportImage.propTypes = {
  platform: PropTypes.string.isRequired,
};
